import React from 'react'
import { Box, Text, Link, SimpleGrid } from "@chakra-ui/react";
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import Typewriter from 'typewriter-effect';
import './home.css'
const Home = () => {
    return (
        <div id="home">
            <SimpleGrid columns={[1, 1, 2, 2]} paddingTop='100px' paddingBottom={'50px'} minChildWidth={''} margin='auto'>
                <Box margin={"auto"} display={'flex'} flexDirection={'column'}>
                    <Box>
                        <Text color='white' fontWeight="700" fontSize={['30px', '35px', '40px']}>Hello World!</Text>
                        <Box color='red.100' fontWeight={'600'} fontSize={['20px', '25px', '28px']}>
                            <Typewriter
                                options={{
                                    strings: ['I am G Prasad Bhat', 'Full Stack Web Developer'],
                                    autoStart: true,
                                    pauseFor: 1000,
                                    loop: true,
                                }}
                            />
                        </Box>
                    </Box>
                    <Box display={'flex'} gap='10px'>
                        <Box marginTop={'5'} >
                            <Box display={'flex'}>
                                <FaGithub size='40px' color='Black' /><Link href='https://github.com/gprasadbhat948231' target={'_blank'} marginLeft='4' color='white' fontSize={'18'}>GitHub</Link>
                            </Box>
                        </Box>
                        <Box marginTop={'5'}>
                            <Box display={'flex'}>
                                <FaLinkedin size='40px' color='Black' /><Link href='https://www.linkedin.com/in/g-prasad-bhat-1b1345155/' target={'_blank'} marginLeft='4' color='white' fontSize={'18'}>Linkedin</Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box margin={'auto'} className='my-img'>
                    <img className='my-img' alt='my img' src="https://avatars.githubusercontent.com/u/107459781?v=4" />
                </Box>
            </SimpleGrid>
        </div>
    )
}

export default Home;